import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { useTokenDisplayDecimals } from '@ui/hooks/useTokenDisplayDecimals';
import { Text } from '@ui/lib/park/ui/text';
import { useTranslation } from 'next-i18next';
import { VStack } from 'styled-system/jsx';

import { EditTpSlType, GenericTradeParams } from '../../../types';
import { headLabelStyle, headValueStyle } from '../styles';

export const EntryPrice = ({
  genericTradeParams,
  type,
}: GenericTradeParams & {
  type: EditTpSlType;
}) => {
  const { t } = useTranslation();

  const priceDisplayDecimals = useTokenDisplayDecimals(
    genericTradeParams?.pair.baseSymbol,
    genericTradeParams?.pair.priceDisplayDecimals,
  );

  const isPositionType = type === EditTpSlType.POSITION;

  return (
    <VStack gap={1} justifyContent="center" alignItems="flex-start">
      <Text css={headLabelStyle}>
        {isPositionType ? t('common.Entry') : t('common.Trigger')}
      </Text>
      <AmountUsd
        css={headValueStyle}
        value={genericTradeParams.entryPrice}
        opts={{
          displayDecimals: priceDisplayDecimals,
        }}
        data-cy="EntryPrice"
        data-cy-value={genericTradeParams.entryPrice}
      />
    </VStack>
  );
};
